import React from "react";

const XbuttonDelete = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="21.0001"
        y="1.55225"
        width="27.5033"
        height="2.19517"
        rx="1.09759"
        transform="rotate(135 21.0001 1.55225)"
        fill="#810101"
      />
      <rect
        x="1.55225"
        y="0.000488281"
        width="27.5033"
        height="2.19517"
        rx="1.09759"
        transform="rotate(45 1.55225 0.000488281)"
        fill="#810101"
      />
    </svg>
  );
};

export default XbuttonDelete;
